import React, { FunctionComponent } from 'react';
import { Box } from '@rebass/emotion';
import {
  Content,
  MainImage,
  layoutWidth,
  IMAGE_STYLE_FIXED,
} from './SeamlessElement1Col.style';
import { SeamlessElementsQuery_seamlessSection_elements_SeamlessElement1Col as SeamlessElement1ColProps } from '../SeamlessSection/__generated__/SeamlessElementsQuery';

const SeamlessElement1Col: FunctionComponent<SeamlessElement1ColProps> = ({
  content,
  image,
  imageStyle,
  contentStyle,
  background,
}) => {
  return (
    <Box
      pt={4}
      backgroundColor={background}
      data-testid="seamless-element-1col"
    >
      {content && (
        <Content
          width={layoutWidth}
          px={2}
          pb={4}
          contentStyle={contentStyle}
          background={background}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
      {image && (
        <MainImage
          width={imageStyle === IMAGE_STYLE_FIXED ? layoutWidth : '100%'}
          px={imageStyle === IMAGE_STYLE_FIXED ? [2, 0] : 0}
          pb={imageStyle === IMAGE_STYLE_FIXED ? 4 : 0}
          src={image}
        />
      )}
    </Box>
  );
};

export default SeamlessElement1Col;
